import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=2a8aedac&scoped=true&"
import script from "./AccountStep.vue?vue&type=script&lang=js&"
export * from "./AccountStep.vue?vue&type=script&lang=js&"
import style0 from "./AccountStep.vue?vue&type=style&index=0&id=2a8aedac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8aedac",
  null
  
)

export default component.exports